import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=32e90197&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.less?vue&type=style&index=0&id=32e90197&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e90197",
  null
  
)

export default component.exports